import moment from 'moment-timezone'

// Device IANA timezone (e.g. "America/Vancouver"), sent to the per-customer
// behavior endpoints so the backend buckets day/hour aggregates in the
// viewer's local time instead of UTC. Resolved once at module load — a device
// zone never changes mid-session, and `tz.guess()` is not free. Falls back to
// '' (backend defaults to UTC) if guessing ever throws in an exotic
// environment. Shared by `useCustomerShoppingBehavior` and
// `useCustomerBehaviorOverview`.
export const BROWSER_TIMEZONE: string = (() => {
  try {
    return moment.tz.guess()
  } catch {
    return ''
  }
})()
